import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './p3-voting-progress-bar.module.less';
import ScreenReaderOnly from '../../../accessibility/ScreenReaderOnly';

const ProgressBar = (props) => {
    const totalPercent = props.percent < 0 ? 0 : props.percent;
    const displayTotalPercent = Math.max(0, Math.min(totalPercent, 100));
    const matchingPercent = props.matchingPercent;
    const percent = 100 - matchingPercent;

    const progressStyle = {
        height: `${percent}%`,
    };

    return (
        <div
            className={classNames(
                styles.classicWrapper,
                props.darkTheme && !props.mini ? styles.matchingGiftWrapper : ''
            )}
        >
            <ScreenReaderOnly>Progresjon: {percent}%</ScreenReaderOnly>
            <span className={styles.progressBarHolder} style={{ height: `${displayTotalPercent}%` }}>
                <span className={styles.animatingBar}>
                    <span style={progressStyle} className={[styles.progressBar, props.className].join(' ')} />
                </span>
            </span>
        </div>
    );
};

ProgressBar.defaultProps = {
    matchingPercent: 0,
    matchingColor: '#0098C1',
    matchingGift: false,
};

ProgressBar.propTypes = {
    percent: PropTypes.number.isRequired,
    matchingColor: PropTypes.string,
    matchingPercent: PropTypes.number,
    matchingGift: PropTypes.bool,
    mini: PropTypes.bool,
    darkTheme: PropTypes.bool,
};

export default ProgressBar;
